import { IApplicationState } from '../../types/redux';

export function selectShouldSendDefaultMessage(state: IApplicationState): boolean | undefined {
  return state.chatModal.shouldSendDefaultMessage;
}
